export const portfolioItems = [
  // --- DISEÑO GRÁFICO (solo branding e identidad) ---
  {
    id: 1,
    title: 'Branding Café Origen',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Identidad visual completa para marca de café artesanal colombiano.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/d454ec08c5d99dea5974d42f027ffae5.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 10,
    title: 'Identidad Visual Boutique',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Branding completo para boutique de moda femenina: logo, paleta y tipografía.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/e9ec0b0336d627c7c614b54986ccd2a8.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 11,
    title: 'Manual de Marca Corporativa',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Diseño y diagramación de manual de marca para empresa de servicios.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/da53f71204c7ae1002b542b34806f712.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 12,
    title: 'Logo Estudio Arquitectura',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Diseño de logotipo geométrico para estudio de arquitectura moderno.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/1be837de1f3ca200933e71fbb34a9b5f.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 13,
    title: 'Branding Restaurante Gourmet',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Identidad visual para restaurante gourmet: logo, menú y papelería.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/773a11d9dd48098f5d04f19aba62b036.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 14,
    title: 'Diseño Editorial Revista',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Diagramación y diseño editorial para revista de cultura y arte.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/ea298f6a6f831fa5d3144578600f9379.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 30,
    title: 'Identidad Marca Natural',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Branding completo para marca de productos naturales y orgánicos colombianos.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/f4c442a6fcab7b4fc17a37d593309ef8.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 31,
    title: 'Rediseño Logo Tech',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Rediseño moderno de identidad para startup tecnológica.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/96714a7e94aebbc7339d284c18ca5641.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 32,
    title: 'Branding Clínica Estética',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Identidad visual sofisticada para clínica de estética y bienestar.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/ca781a5f149b35f9d0eb3e8df91ab6c6.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 33,
    title: 'Papelería Corporativa',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Diseño de papelería institucional: sobres, carpetas, hojas membretadas.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/f442eb2690e5ad69cd2a47d49f96bbe3.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 34,
    title: 'Iconografía Marca',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Sistema de iconos personalizados para aplicación de servicios financieros.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/d70aa9f5b75aac855153d8442a69ccd6.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 35,
    title: 'Catálogo Fashion',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Diseño de catálogo fotográfico para colección de moda colombiana.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/3b7b7e99d529bec7b90a7186d595e619.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 36,
    title: 'Presentación Pitch Deck',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Diseño de presentación ejecutiva para startup en ronda de inversión.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/389d47197ed61e9ea7267cba8a483d29.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 37,
    title: 'Branding Panadería Artesanal',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Identidad visual cálida y artesanal para panadería boutique.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/c0d123f2356e206a24b6d64d66fa524e.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 38,
    title: 'Tipografía Display',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Diseño tipográfico personalizado para campaña publicitaria de gran impacto.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/51fe1a6dbeeb290253e360e5bab04459.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 39,
    title: 'Logo Marca Deportiva',
    category: 'grafico',
    categoryLabel: 'Diseño Gráfico',
    description: 'Identidad dinámica y energética para marca de indumentaria deportiva.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/e24a873cee9ac878eb92250761cd17b3.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },

  // --- PUBLICIDAD IMPRESA (material impreso + prendas + merchandising) ---
  {
    id: 5,
    title: 'Volante Evento Corporativo',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño de volante y afiche para evento empresarial de alto perfil.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/9ae4cd95be6261a74e9d5b53b3ee1907.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 8,
    title: 'Tarjetas de Presentación',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño de tarjetas premium con acabados especiales para ejecutivos.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/ab1b5d918f88a00beda4d47c6f4df37f.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 15,
    title: 'Afiche Concierto Musical',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño de afiche para concierto de música en vivo con tipografía impactante.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/3d1c77742a551aad71117843f6f2095e.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 16,
    title: 'Pendón Feria Comercial',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño de pendón y banner para stand en feria comercial.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/16730200d7d6ae64f24bcc634c1e881a.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 17,
    title: 'Catálogo de Productos',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño y diagramación de catálogo impreso para empresa de productos.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/786e4da3154c4ff8cde39c772e8d59d8.png',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 18,
    title: 'Valla Publicitaria',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño de valla publicitaria para campaña exterior de gran formato.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/f3017aa8e84c3e8a682434ebf186ba9b.png',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 27,
    title: 'Etiqueta Producto Premium',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño de etiqueta para producto premium con acabados especiales y tipografía refinada.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/0d28c0967877d5185bd6d63117642d3d.png',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 28,
    title: 'Menú Restaurante',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño de menú impreso para restaurante gourmet con fotografía de platos.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/d0126b441acff10c1f6c684c6df01f86.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  // --- PRENDAS Y MERCHANDISING ---
  {
    id: 50,
    title: 'Camiseta Corporativa',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño de camiseta corporativa con sublimación para empresa de tecnología.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/d9224a032ee6f27e2add71b32f600887.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 51,
    title: 'Uniforme Empresarial',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño de uniformes con bordado para equipo comercial.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/34175fd0da6bbbd2d312d2fbfe91ad20.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 52,
    title: 'Gorra Publicitaria',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño e impresión de gorras publicitarias con logo bordado para campaña.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/149bec2fef1c83413d7ba8ae45c8f047.png',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 53,
    title: 'Bolsa Corporativa',
    category: 'impresa',
    categoryLabel: 'Publicidad Impresa',
    description: 'Diseño de bolsas de tela con serigrafía para merchandising de marca.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/0c25656da33a3006f5eea964142a4f23.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },

  // --- CONTENIDO DIGITAL ---
  {
    id: 2,
    title: 'Flyer Promocional Restaurante',
    category: 'redes',
    categoryLabel: 'Contenido Digital',
    description: 'Flyer digital para promoción de menú especial en redes sociales.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/933ba9a08a88c603aa91929f93018478.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 6,
    title: 'Post Lanzamiento de Producto',
    category: 'redes',
    categoryLabel: 'Contenido Digital',
    description: 'Diseño de post para lanzamiento de nuevo producto en Instagram.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/486f55ce44f921a44976f100256effdf.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 19,
    title: 'Flyer Evento Empresarial',
    category: 'redes',
    categoryLabel: 'Contenido Digital',
    description: 'Diseño de flyer digital para evento corporativo difundido en redes.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/978f4a7dc301d2ff58fd8699a8e22652.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 20,
    title: 'Contenido Fitness & Gym',
    category: 'redes',
    categoryLabel: 'Contenido Digital',
    description: 'Pack de contenido visual mensual para gimnasio en Instagram y Facebook.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/48c3170133554c844e50911cbaecf5dd.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 21,
    title: 'Flyer Oferta Temporada',
    category: 'redes',
    categoryLabel: 'Contenido Digital',
    description: 'Diseño de flyer de oferta especial para temporada alta en redes sociales.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/fd1e7004ea79aac3a83c42dfa0e50f5f.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 22,
    title: 'Post Marca de Moda',
    category: 'redes',
    categoryLabel: 'Contenido Digital',
    description: 'Contenido visual para feed de Instagram de marca de moda colombiana.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/1ef2f51e53308db3f13d6223c4714aae.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },

  // --- EMPAQUES ---
  {
    id: 3,
    title: 'Empaque Cosmético Luna',
    category: 'empaques',
    categoryLabel: 'Empaques',
    description: 'Diseño de empaque premium para línea de cosméticos naturales.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/58e0973eee002ec63744803985a8a74d.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 7,
    title: 'Caja Producto Artesanal',
    category: 'empaques',
    categoryLabel: 'Empaques',
    description: 'Diseño de caja y etiqueta para producto artesanal exportación.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/5351124417395f914263f9ff3227c245.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 23,
    title: 'Empaque Café Especial',
    category: 'empaques',
    categoryLabel: 'Empaques',
    description: 'Diseño de empaque para café de especialidad colombiano con identidad de origen.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/89a3abdc1dbdd466eb05b205069266d5.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 24,
    title: 'Empaque Snack Saludable',
    category: 'empaques',
    categoryLabel: 'Empaques',
    description: 'Packaging para línea de snacks saludables con colores vivos y tipografía moderna.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/8c8d1c6ef032084332f57799daf92b1c.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 25,
    title: 'Empaque Velas Aromáticas',
    category: 'empaques',
    categoryLabel: 'Empaques',
    description: 'Diseño de caja y etiqueta para línea de velas aromáticas artesanales.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/0b7a8d6d8faedbe8d6c54f970b8cfb8b.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },
  {
    id: 26,
    title: 'Empaque Té & Infusiones',
    category: 'empaques',
    categoryLabel: 'Empaques',
    description: 'Packaging para colección de tés e infusiones naturales con diseño botánico.',
    image: 'https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/43bc64c600f2860dc6de35cb712aefeb.jpeg',
    orientation: 'portrait',
    videoUrl: undefined,
    videoType: undefined,
  },

  // --- VIDEO ---
  {
    id: 4,
    title: 'Reels Restaurante Fuego',
    category: 'video',
    categoryLabel: 'Video',
    description: 'Edición de reels dinámicos para restaurante gourmet en Bogotá.',
    image: '',
    orientation: 'reel',
    videoUrl: 'https://storage.readdy-site.link/project_files/56c71ce7-2f1f-4dce-9c8c-f4142bab2e5c/8f7ce979-dd85-4109-9bf3-83e27a0c57ae_WhatsApp-Video-2026-04-13-at-7.55.45-PM.mp4?v=f4d07a1490a19483e646faf80ea49923',
    videoType: 'mp4',
  },
  {
    id: 9,
    title: 'Reel 2',
    category: 'video',
    categoryLabel: 'Video',
    description: 'Reel dinámico para redes sociales.',
    image: '',
    orientation: 'reel',
    videoUrl: 'https://storage.readdy-site.link/project_files/56c71ce7-2f1f-4dce-9c8c-f4142bab2e5c/7fb281b1-096c-427e-9e7a-748b5ab28369_WhatsApp-Video-2026-04-13-at-8.29.52-PM.mp4?v=4e8d5c4d062a4cd37b03dbd1550e498e',
    videoType: 'mp4',
  },
  {
    id: 60,
    title: 'Reel 3',
    category: 'video',
    categoryLabel: 'Video',
    description: 'Reel dinámico para redes sociales.',
    image: '',
    orientation: 'reel',
    videoUrl: 'https://storage.readdy-site.link/project_files/56c71ce7-2f1f-4dce-9c8c-f4142bab2e5c/74ee362d-3368-4293-baed-6999bd012810_tecno.mp4?v=942a190c85cde3550642ca2c24f04c1a',
    videoType: 'mp4',
  },
  {
    id: 61,
    title: 'Reel 4',
    category: 'video',
    categoryLabel: 'Video',
    description: 'Reel dinámico para redes sociales.',
    image: '',
    orientation: 'reel',
    videoUrl: 'https://storage.readdy-site.link/project_files/56c71ce7-2f1f-4dce-9c8c-f4142bab2e5c/4fa9ceb2-e4f9-43fc-bde0-5a2575f20100_lion-navidad.mp4?v=06dc7ff94dcf2bde1f1104afba56abce',
    videoType: 'mp4',
  },
  {
    id: 62,
    title: 'Reel 5',
    category: 'video',
    categoryLabel: 'Video',
    description: 'Reel dinámico para redes sociales.',
    image: '',
    orientation: 'reel',
    videoUrl: 'https://storage.readdy-site.link/project_files/56c71ce7-2f1f-4dce-9c8c-f4142bab2e5c/183360e0-3e9a-44c1-a2dd-bf6afe6209d3_LION_PAGINA_WEB.mp4?v=d8075184cf13d51d6b64b017330a2ac6',
    videoType: 'mp4',
  },
  {
    id: 63,
    title: 'Reel 6',
    category: 'video',
    categoryLabel: 'Video',
    description: 'Reel dinámico para redes sociales.',
    image: '',
    orientation: 'reel',
    videoUrl: 'https://storage.readdy-site.link/project_files/56c71ce7-2f1f-4dce-9c8c-f4142bab2e5c/7bdc7b28-7f6a-4e3a-95fb-16a0c021af04_WhatsApp-Video-2026-04-21-at-9.03.33-PM.mp4?v=c9e0a0462070397854ad36e25e519325',
    videoType: 'mp4',
  },
  {
    id: 64,
    title: 'Reel 7',
    category: 'video',
    categoryLabel: 'Video',
    description: 'Reel dinámico para redes sociales.',
    image: '',
    orientation: 'reel',
    videoUrl: 'https://storage.readdy-site.link/project_files/56c71ce7-2f1f-4dce-9c8c-f4142bab2e5c/37130b5f-fd4e-4fb3-8902-abd19965f066_WhatsApp-Video-2026-04-21-at-9.07.35-PM.mp4?v=533d296bb69f1df2e330c902bf8aa52c',
    videoType: 'mp4',
  },

];
